import moment from "moment";
import React, { useEffect, useState, Component } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { new_image_thumbnail, sneakPeekBerry, sneakpreview, timetable } from "shared/images/images";
import { ItemsService, LocationService, SalesService } from "shared/services";
import store from 'features/store';
import { ToggleSideBar, MyAccountMenuList, removeSideBar } from "../base/auth-pages/MyAccount/MyAccountMenuList";
import { isAuthorized, logout } from "shared/settings/auth";
import VideoThumbnail from "shared/video-thumbnail/VideoThumbnail";
import './auctionsp.scss';
import { eye, RightArrowLine } from "shared/assets/icons";
import { Loader } from "shared/hoc/loader/Loader";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

function AuctionSneakPeekSaleItemfn(props) {
    const params = useParams();
    const [imageList, setImageList] = useState([]);
    const [item, setitem] = useState({});
    const [saleID, setsaleID] = useState(params?.saleId);
    const [sale, setsale] = useState({});
    const [locImg, setlocImg] = useState("");
    const [locationDetails, setlocationDetails] = useState({});
    const [watch, setwatch] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [videoThumbnails, setVideoThumbnails] = useState({});
    const [itemID, setItemID] = useState(params?.itemId);
    const [disableWatch, setDisableWatch] = useState(false);
    const [activeMediaIndex, setActiveMediaIndex] = useState('');

    useEffect(() => {
        loading();
        return () => {

        }
    }, [])

    const loading = async () => {
        await getSale()
        setPageLoading(false);
    }
    const getSale = async() => {
        const saleDetailData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "locationid"],
            // filter: [{ "field": "id", "value": params?.saleId, "op": "=", "join": "AND" }],
            // "page": { "size": 1 }
        };
        await  SalesService.getSaleDetails(params?.saleId,saleDetailData).then(async(response) => {
            let saleDetail = response?.data?.data?.[0] || {}
            setsale(saleDetail)
            await itemList();
            await getLocData(saleDetail?.locationid);

        }).catch((err) => {
        })
    }

    const getLocData = async (id) => {
        await LocationService.getLocationDetails(id, { data: {} }).then(
            location => {
                setlocationDetails(location.data.data[0])

                // google analytics config for item list page

            }
        ).catch((error) => {
            // TODO: Error message handle
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
        });
        const locationImageData = { "filter": [{ "field": "locationid", "value": id, "op": "=", "join": "AND" }] };
        await LocationService.getLocationImagesList(locationImageData).then(
            resp => {
                let data = resp?.data?.data
                let locationImage = {}
                data?.map((i) => {
                    locationImage[i?.name] = i?.url
                })
                setlocImg(locationImage)
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
    }

    const getItemImages = async (id) => {
        const imageListPostData = {
            "filter": [{ "field": "itemid", "value": id, "op": "=", "join": "AND" }],
            "field": ["id", "name", "type", "url", "itemid", "isdisplayimage", "displayorder", "thumbnailurl"],
            "sort": [{ "field": "displayorder", "direction": "asc" }],
            "page": { "size": 1000 }
        };

        await ItemsService.getItemImagesList(imageListPostData).then(resp => {
            setImageList(resp?.data?.data)
        }).catch(error => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
        });

    }
    const itemList = async () => {
        await ItemsService.getMemberItemDetail(itemID, saleID).then(async (resp) => {

            resp = resp?.data?.data[0]
            setitem(resp)
            await getItemImages(resp?.id)
            await getWatchList(resp?.id)
        }).catch(error => {
        });

    }
    const getWatchList = async (id) => {
        if (isAuthorized()) {
            const data = {
                "sort": [{ "field": "id", "direction": "desc" }],
                "filter": [{ "field": "itemid", "value": [[id]], "op": "IN", "join": "AND" }],
                "field": ["itemid"],
                "page": { "size": 2 }
            };
            await ItemsService.getWatchListItem(data).then(
                response => {
                    const watch = response.data.data;
                    setwatch(watch.length > 0)
                }
            ).catch(error => {
                // this.emitData();
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(props.history, false);
                }
            });
        }
    }
    const watching = () => {
        setDisableWatch(true);
        if (!isAuthorized()) {
            return
        }
        if (watch) {
            const removeData = {
                "data": {
                    "itemIds": [item?.id]
                }
            };
            ItemsService.removeFromWatch(removeData).then(
                response => {
                    setwatch(false);
                    setDisableWatch(false);
                }
            ).catch(error => {
            });
        } else {
            const addData = {
                "data": [
                    {
                        "itemid": item?.id
                    }
                ]
            }
            ItemsService.addToWatch(addData).then(
                response => {
                    setwatch(true);
                    setDisableWatch(false);
                }
            ).catch(error => {
            });
        }

    }

    const moreSaleForLocation = () => {
        const location = locationDetails;
        if (location.id) {
            const locationUrl = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            props.history.push(locationUrl);
        }
    }

    const videoPlayToggle = (index) => {
        setActiveMediaIndex(index);
    }

    if (pageLoading)
        return (
            <div className="h-100 d-flex align-items-center justify-content-center">
                <Loader />
            </div>)
    return (
        <div className="asp-items">
            <Helmet>
                <title>CTBids | Premier Auction Sneak Peek</title>
            </Helmet>
            {props.user.suspensionstatus === "ALL" ?
                <div className="w-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', width: '60%' }}>
                        You are currently suspended from bidding on CTBids. Please reach out to <a style={{ color: '#A50050' }} href="tel:(844) 4-BID-HELP" >(844) 4-BID-HELP</a>  or email <a style={{ color: '#A50050' }} href="mailto:ctbidshelp@caringtransitions.com">ctbidshelp@caringtransitions.com</a> if you have any questions.
                    </div>
                </div> :
                <div className="asp">
                    <div className="asps_container w-100">
                        <div className="asp_container">
                            <div className="asp-header">
                                <div>
                                    <div className="header">
                                        <img className="headlogo" src={sneakPeekBerry} />
                                        <div className="title">

                                            <div className="atitle">Auction Sneak Peek</div>
                                            <div className="head_cont">Item : &nbsp;{item?.title}</div>
                                            <div className="head_cont">Category : &nbsp;{item?.category}</div>
                                            <div className="head_cont">Live Auction tentatively starts {moment(item?.salestarttime).format("MMMM DD")}</div>
                                        </div>
                                    </div> <div className="d-flex flex-wrap align-items-center my-2">
                                        <Button className={`watchbtn  ${item?.iswatch ? "watching" : ""}`} onClick={() => { watching(); }} disabled={disableWatch}>Watch {eye}</Button>
                                        {saleID != undefined && <Button className="btn-grey m-2" onClick={() => {
                                            props.history.push({ pathname: `/my-account/premier/auction-sneak-peak-sale/${saleID}`, state: { sale: sale, itemDetails: item } });
                                        }}>More Items From This Auction</Button>}
                                        <Button className="btn-grey m-2" onClick={() => {
                                            props.history.push({ pathname: "/my-account/premier/auction-sneak-peak" });
                                        }}>Return To Sneak Peek Listings</Button>
                                    </div>
                                </div>
                                <div className="location-card">
                                    <div className="location-head">
                                        <div className="left">
                                            <div className="imgcontainer">
                                                <img className="location-img" src={locImg?.banner || locImg?.profile || new_image_thumbnail} alt="location image" />
                                            </div>
                                        </div>
                                        <div className="right">
                                            <div className="locationtitle"> {locationDetails?.title}</div>
                                            <div className="locationcity my-2">{locationDetails?.city}</div>
                                            {locationDetails?.auctioneerlicense && <div className='text-secondary mt-3' style={{ wordBreak: "break-all" }}>License: {locationDetails?.auctioneerlicense}</div>}

                                        </div>
                                    </div>
                                    <Button className=' w-100 btn-grey rounded text-bold estate-resp d-flex gap-2 justify-content-center align-items-center'
                                        onClick={() => {

                                            const url = locationDetails?.locationcode ? `/estate-sales/${locationDetails?.locationstatecode}/${locationDetails?.locationcode}` : `/estate-sales/${locationDetails?.locationstatecode}`;
                                            props.history.push(url);
                                        }}>
                                        <div>View Estate Sales</div>
                                        <div > {RightArrowLine}</div>
                                    </Button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="itemlist">
                        <Row xs={1} sm={2} md={3} lg={4}>
                            {imageList?.map((media, index) => {
                                let url = media.thumbnailurl ? media.thumbnailurl : media.url
                                return (
                                    <Col key={`items_${index}`} className=" clickable my-2">
                                        <div className={"itemcard"}>
                                            <div className="image-card">
                                                <div className="img-container">
                                                    { media.type === 'image' ?  <img src={url} className="items-image" alt="item"></img>:
                                                       activeMediaIndex == index ?  <video disablePictureInPicture src={media.url} controls controlsList="nodownload" autoPlay="autoplay" webkit-playsinline playsinline className="items-image"></video>
                                                       : <VideoThumbnail
                                                       className="items-image"
                                                       videoUrl={media.url}
                                                       thumbnailHandler={(thumbnail) => {
                                                           setVideoThumbnails({ 'videoThumbnails': { videoThumbnails, [media.id]: thumbnail } })
                                                       }}
                                                       onClick={() => { videoPlayToggle(index) }}
                                                   />
                                                    }
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </div>
                    <div className="d-flex flex-row justify-content-center mrbt-2 sneak-item-resp py-5">
                        <img className="logobid" src={sneakpreview} />
                    </div>
                </div>}
        </div>
    )
}
class AuctionSneakPeekSaleItem extends Component {
    constructor(props) {
        super(props);
        this.buyrId = this.props.user.id
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        ToggleSideBar();
        window.addEventListener('resize', ToggleSideBar);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', ToggleSideBar);
        removeSideBar();
    }

    render() {
        return <AuctionSneakPeekSaleItemfn {...this.props} />
    }
}

export default connect(state => state)(AuctionSneakPeekSaleItem);